import { useMutation } from '@tanstack/react-query'

import API from '@shared/services/src/API'

export function useGetPatient() {
  return useMutation({
    mutationFn: (id) => API.patients.id(id).details({ skipHandling: true }),
  })
}
